export class ShipmentReportEmpViewModel{
    picking: number = 0;
    transferring: number = 0;
    transferReturning: number = 0;
    delivering: number = 0;
    returning: number = 0;
    pickupComplete: number = 0;
    deliveryComplete: number = 0;
    returnComplete: number = 0;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/view-model/shipmentReportEmp.viewModel.ts